"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const mui_1 = require("tss-react/mui");
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const utils_1 = require("data/transactions/utils");
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const QTypography_1 = __importDefault(require("components/MUIWrappers/QTypography"));
const styles_1 = require("../styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const NotesField = ({ attributes, forceStatic, callbacks, editable, SHOW_ALL, txn, wrapClass, editClass, hoverClass, currEditFieldName, enableAutoFocus, wrapText, field, staticValue, focusField, }) => {
    var _a;
    const { classes, theme } = useStyles();
    const c2RTxnClass = (0, utils_1.isC2RTransaction)(txn) ? classes.txnInC2RText : '';
    return (<styles_1.RegListItem {...attributes} className={(0, classnames_1.default)(classes.regItem, 'flex2', wrapClass, editClass, hoverClass, c2RTxnClass)}>
      {SHOW_ALL &&
            // eslint-disable-next-line react/jsx-no-useless-fragment
            <>
        {editable && !forceStatic && currEditFieldName === 'notes' ?
                    <TextField_1.default variant="standard" 
                    // @ts-expect-error: Property 'register' does not exist on type 'Components<BaseTheme>'.
                    InputProps={{ disableUnderline: (_a = theme.components) === null || _a === void 0 ? void 0 : _a.register.noUnderline }} className={classes.regInput} onFocus={callbacks.handleFocus} autoFocus={enableAutoFocus} placeholder="Memo" value={txn.memo || ''} onChange={(e) => { var _a; return (_a = callbacks.handleChange) === null || _a === void 0 ? void 0 : _a.call(callbacks, e, 'notes'); }} 
                    // onBlur={(e) => onFieldBlur(e, 'notes')}
                    inputRef={(input) => {
                            focusField.current = input; // eslint-disable-line
                        }}>
          </TextField_1.default> :
                    // @ts-expect-error: missing props
                    <QTip_1.default wrapOnly title={wrapText ? null : txn.memo} wrapId={`${txn.id}-${field}`}>
            <QTypography_1.default clickable={!forceStatic ? 'true' : null} thinFont className={classes.regItemCore}>
              {txn.memo || staticValue}
            </QTypography_1.default>
          </QTip_1.default>}
      </>}
    </styles_1.RegListItem>);
};
exports.default = NotesField;
